
export function targetStageSafetyCheck(targetStage: string) {
	if (targetStage !== "kizidev")
		throw new Error("Safety check to prevent changes directly on test/acc/prod.");
}
